export const requestMobileBrowserChromeCollapse = () => {
  if (typeof window === 'undefined') return

  const ua = window.navigator.userAgent
  const isIOS = /iPad|iPhone|iPod/.test(ua)
    || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)

  if (!isIOS) return

  document.documentElement.classList.add('ios-browser-chrome-space')

  if (window.scrollY <= 1) {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 1, left: 0, behavior: 'instant' as ScrollBehavior })
    })
  }
}
